import { render, staticRenderFns } from "./deviceReg.vue?vue&type=template&id=60d4d720&scoped=true&"
import script from "./deviceReg.vue?vue&type=script&lang=js&"
export * from "./deviceReg.vue?vue&type=script&lang=js&"
import style0 from "./deviceReg.vue?vue&type=style&index=0&id=60d4d720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4d720",
  null
  
)

export default component.exports